/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__Zone_disable_customElements = true;

/**
 * Note: Passive event listeners were removed because they broke preventDefault()
 * functionality needed for touch-based drag operations in the app.
 * Individual components now handle passive vs non-passive events as needed.
 */

// experiments when trying to improve idb performance
// (window as any).__Zone_disable_XHR = true;
// (window as any).__Zone_disable_timers = true;
// (window as any).__Zone_disable_EventTarget = true;
